<template lang="pug">
.container-playlist(
    v-if='playListTree.PlayItems.length > 0',
    :class="{ 'menuboardview-active': treeViewParams.menuBoardMode.value, 'no-play': !shouldPlay(playListTree), 'no-indent': treeViewParams.showIdentation.value, 'hidden': !shouldPlay(playListTree) && treeViewParams.showOnlyPlayable.value }"
  )
  .playlist-row(
    :class="{ 'no-play': !shouldPlay(playListTree), 'menuboardview-active': treeViewParams.menuBoardMode.value }",
    @click="playMediumLocal(playListTree)"
  )
    MediumIcon.playitem-icon(:medium="playListTree")
    span(v-if='playListTree.mediumname') {{ playListTree.mediumname }} &nbsp;
    font-awesome-icon.time-restriction-exists(
      v-if='itemHasTimeRestrictions(playListTree) && !treeViewParams.showRestrictions.value',
      icon="clock"
    )
    .second-row(v-if='treeViewParams.showRestrictions.value && itemHasTimeRestrictions(playListTree)')
      ScheduleDateList(
        :id="'PlayListTree-scheduleDateList' + playListTree.PlayListItemId ? playListTree.PlayListItemId : playListTree.mediumname",
        :restrictions='playListTree.PlayListItem_DateRestrictions'
      )
      ScheduleDayTimeList(
        :id="'PlayListTree-scheduleDayTimeList' + playListTree.PlayListItemId ? playListTree.PlayListItemId : playListTree.mediumname",
        :restrictions='playListTree.PlayListItem_DaytimeRestrictions', dayLabelLength='short'
      )
  .playitem-row(
    v-for='playitem in playListTree.PlayItems',
    :class="{ 'menuboardview-active': treeViewParams.menuBoardMode.value, 'no-play': !shouldPlay(playitem), 'no-indent': treeViewParams.showIdentation.value, 'hidden': !shouldPlay(playitem) && treeViewParams.showOnlyPlayable.value }",
    v-if='playitem.type.startsWith("PlayList") || !treeViewParams.showOnlyPlaylists.value || treeViewParams.menuBoardMode.value'
  )
    .first-row
      .img(v-if='treeViewParams.showThumbs.value && !playitem.type.startsWith("PlayList")')
        img(:src='getThumbnail(playitem)', @click="playMediumLocal(playitem)")
      .playitem-name(v-if='!playitem.type.startsWith("PlayList")')
        .name
          MediumIcon.playitem-icon(:medium="playitem")
          span  {{ playitem.mediumname }} &nbsp;
          font-awesome-icon.time-restriction-exists(v-if='itemHasTimeRestrictions(playitem)', icon="clock")
    .second-row(v-if='treeViewParams.showRestrictions.value && itemHasTimeRestrictions(playitem) && !playitem.type.startsWith("PlayList")')
      ScheduleDateList(:id="'PlayListTree-scheduleDateList' + playitem.id" :restrictions='playitem.PlayListItem_DateRestrictions')
      ScheduleDayTimeList(:id="'PlayListTree-scheduleDayTimeList' + playitem.id" :restrictions='playitem.PlayListItem_DaytimeRestrictions', dayLabelLength='short')
    PlayListTree(v-if='playitem.PlayItems.length > 0', :playListTree='playitem', :timestampForTree='timestampForTree', :treeViewParams='treeViewParams', @reloadPlayListTree='reloadPlayListTree')
  el-dialog(:close-on-click-modal="false", :visible.sync="playMediumVisible", @close='closePlayMedium(); playMediumVisible = false; playedMedium = undefined',  append-to-body, width='65%')
    Player(:playedMedium='playedMedium')
</template>
<script>

import ScheduleDateList from '../Common/ScheduleDateList'
import ScheduleDayTimeList from '../Common/ScheduleDayTimeList'
import Player from './../File/Player'
import MediumIcon from './../Common/MediumIcon'
import mediaUtils from '../Common/mediaUtils.mixin'
import textUtils from '../Common/textUtils.mixin'
import listItemMixin from './ListItem.mixin'
import restrictions from '../Common/restrictions.js'

export default {
  mixins: [
    textUtils,
    mediaUtils,
    listItemMixin
  ],
  components: {
    ScheduleDateList,
    ScheduleDayTimeList,
    Player,
    MediumIcon,
    restrictions,
    PlayListTree: () => import('./PlayListTree.vue')
  },
  props: {
    'playListTree': {
      required: true
    },
    'timestampForTree': {
      required: true
    },
    'treeViewParams': {
      required: true
    }
  },
  data () {
    return {
      playedMedium: undefined,
      playMediumVisible: false
    }
  },
  methods: {
    closePlayMedium () {
      this.reloadPlayListTree()
    },
    reloadPlayListTree () {
      this.$emit('reloadPlayListTree')
    },
    playMediumLocal (item) {
      const mediumInStore = this.$store.state.Medium.media_list.find(m => m.id === item.MediumId)
      this.playMedium(mediumInStore)
    },
    getThumbnail (playitem) {
      return this.getMediumThumbnailPath(this.getMediumById(playitem.MediumId), 'low')
    },
    shouldPlay (playitem) {
      return restrictions.shouldPlay(playitem, this.timestampForTree)
    }
  }
}
</script>
<style lang="scss" scoped>
@import "../../../theme-m4b/src/common/var.scss";
  .container-playlist {
    border: 1px solid $--border-color-extra-light;
    border-radius: 3px;
    margin-left: 10px;
    &.menuboardview-active {
      border: 0px;
      margin-left: 0px;
    }
    // margin-bottom: 7px;
    // width: 100%;
    &.no-indent {
      margin-left: 0px;
    }
  }
  .playitem-icon {
    margin-right: 10px;
    font-size: $--font-size-small;
    opacity: 0.5;
  }
  .playitem-row {
    font-size: $--font-size-base;
    padding: 5px 0px 5px 12px;
    border-bottom: 1px solid $--border-color-light;
    background-color: rgba(silver, 0.1);
    &.menuboardview-active {
      background-color: rgba(silver, 0.0);
      padding-left: 0px;
    }
    .first-row  {
      display: flex;
      align-items: center;
    }
    .second-row  {
      margin-top: 10px;
      display: flex;
      align-items: center;
    }

    .img {
      width: 50px;
      text-align: center;
      margin-right: 10px;
      cursor:zoom-in;
    }
    .img > img {
      max-width: 50px;
      max-height: 50px;
    }
    &.no-indent {
      padding-left: 0px;
    }
  }
  .playitem-row:last-child {
    border-bottom: 0px;
  }
  .playlist-row {
    padding: 12px;
    background-color: $--border-color-light;
    border-radius: 3px;
    cursor:zoom-in;
    .second-row  {
      margin-top: 10px;
      display: flex;
      align-items: center;
    }
    &.menuboardview-active {
      display: none;
    }
  }
  .no-play {
    background-color: rgba($--color-danger, 0.2);
    &.menuboardview-active {
      display: none;
    }
  }
  .hidden {
    display: none;
  }
  .time-restriction-exists {
    color: $--color-warning;
    margin-left: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Medium/PlayListTree.vue